import { mdiApplicationSettings } from '@mdi/js'

export default [
  {
    title: 'تنظیمات اپلیکیشن',
    icon: mdiApplicationSettings,
    action: 'can_see_application_settings',
    resource: 'all',
    children: [
      {
        title: 'دسته بندی های اپ',
        to: 'app-categories',
        action: 'can_see_application_settings',
        resource: 'all',
      },
      {
        title: 'اسلایدرهای اپ',
        to: 'app-collections',
        action: 'can_see_application_settings',
        resource: 'all',
      },
    ],
  },
]
